(() => {
  function initialise(scope) {
    scope.querySelectorAll('[data-litq-carousel]').forEach((section) => {
      section.classList.add('is-alternating');
    });
    scope.querySelectorAll('.ac-litq__photo-dialog').forEach((dialog) => {
      if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const root = dialog.closest('.ac-litq');
      let opener;
      root.querySelectorAll(`[data-litq-photo-open="${dialog.id}"]`).forEach((link) => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', dialog.id);
        link.addEventListener('click', (event) => {
          event.preventDefault();
          if (dialog.open) return;
          opener = link;
          dialog.showModal();
        });
      });
      dialog.querySelector('[data-litq-photo-close]').addEventListener('click', () => dialog.close());
      let backdrop = false;
      const outside = (event) => {
        const rect = dialog.getBoundingClientRect();
        return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
      };
      dialog.addEventListener('pointerdown', (event) => { backdrop = outside(event); });
      dialog.addEventListener('click', (event) => { if (backdrop && outside(event)) dialog.close(); backdrop = false; });
      dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus({ preventScroll: true }); });
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
